<template>
    <Dialog :modal="true" v-model:visible="approve_pop"
        :header="t('assetManagement.Disposal.Popuplabel.ApproveHeading')" @after-hide="IsClear"
        :breakpoints="{ '960px': '75vw', '640px': '90vw' }" :style="{ width: '50vw' }">
        <b-container fuild class="disposal_asset_details">
            <b-row>
                <b-col lg="6" class="field">
                    <div>
                        <p>{{ t('assetManagement.Disposal.Asset Name') }} : {{ propsdatas.AssetName }}</p>
                    </div>
                </b-col>
                <b-col lg="6" class="field">
                    <div>
                        <p>{{ t('assetManagement.Disposal.FlaggedDate') }} : {{ propsdatas.FlaggedDate }}</p>
                    </div>
                </b-col>
            </b-row>
            <b-row class="mb-4">
                <b-col lg="6" class="field">
                    <div>
                        <p>{{ t('assetManagement.Disposal.ReasonforDisposal.ReasonDisposal') }} :{{
                            propsdatas.ProposedDisposalMethodName }}</p>
                    </div>
                </b-col>
                <b-col lg="6" class="field">
                    <div>
                        <p>{{ t('assetManagement.Disposal.Proposedmethod') }} : {{ propsdatas.DisposalMethodName }}</p>
                    </div>
                </b-col>
            </b-row>
            <!-- <b-row>
                <b-col lg="6" class="field">
                    <div>
                        <p>Expected Proceeds:{{ propsdatas.ExpectedProceeds}}</p>
                    </div>
                </b-col>
            </b-row> -->
            <b-row>
                <Footer @cancel="IsClear" :label="t('assetManagement.Disposal.Btn.Approve')" @save="Approve" />

            </b-row>
        </b-container>
    </Dialog>
    <CreateSuccessully :visible="successpop" content="Approved Successfully" @ok="closetrigger()" />
</template>
<script lang="ts">
import { defineComponent, ref } from 'vue'
import TextArea from '../../../../../../../components/FormComponents/TextArea.vue';
import Footer from '../../../../../../../components/FormComponents/Footer.vue';
import { DisposalApprovalModels } from '../../../../../../../modules/Inventory/pages/AssetManagement/Transaction/model/Disposal/disposalModel'
import DisposalService from '../../../../../../../modules/Inventory/Service/AssetManagement/DisposalService';
import CreateSuccessully from "../../../../../../../components/FormComponents/createdsuccessfully.vue";
import { useI18n } from 'vue-i18n';
export default defineComponent({
    components: {
        TextArea,
        Footer,
        CreateSuccessully
    },
    props: {
        approve_pop: {
            type: Boolean,
            default: false,
        },
        datas: {
            type: Object,
            default: null,
        }
    },
    setup(props, { emit }) {
        const { t } = useI18n();
        const approve_pop = ref(props.approve_pop);
        const propsdatas = ref(props.datas)
        const successpop = ref(false)
        let usersData;
        let SessionUserData = localStorage.getItem("UsersData");
        if (SessionUserData !== null) {
            usersData = JSON.parse(SessionUserData);
        }
        const updateApproval = ref<DisposalApprovalModels>({
            id: propsdatas.value.Id,
            approvalStatus: "1",
            approvedBy: usersData.UserId,
            rejectionReason: "",
            barcode: "",
            barcodeNumber: 0,
            status:"2"
            
        })
        async function Approve() {
            try {
                let msg;
                updateApproval.value.approvedBy = updateApproval.value.approvedBy.toString()
                const data_response = await DisposalService.updateapproval(updateApproval.value);
                msg = data_response["ErrorInfo"].ErrorCode;
                if (msg == null) {
                    successpop.value = true;
                }
            } catch (error) {
                console.log(error);
            }
        }
        function closetrigger() {
            successpop.value = false;
            IsClear();
        }
        function IsClear() {
            approve_pop.value = false;
            emit('closepopup', approve_pop.value);

        }
        return {
            approve_pop,
            IsClear,
            Approve,
            updateApproval,
            usersData,
            propsdatas,
            successpop,
            closetrigger,
            t
        }
    },
})
</script>
<style lang="scss" scoped>
.disposal_asset_details p {
    font-size: 14px;
    line-height: 18px;
    color: #000;
}
</style>